// extracted by mini-css-extract-plugin
export default {"pcContainer":"e8VqWmcG","fixedBar":"ANfOVmZx","fixedBtn":"LYIE3G4X"};